import { render } from "./AppCountdown.vue?vue&type=template&id=22d119be"
import script from "./AppCountdown.vue?vue&type=script&lang=js"
export * from "./AppCountdown.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__